export default __webpack_public_path__ + "static/media/logo.4c8e42a2.svg";